
import React from "react"
import { Panel } from "@ronuse/norseu/core/panels";
import { CompaniesUsingNorseu } from "../../utils/companies_using_norseu"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

export class ComponentsOverviewPage extends React.Component {

	static Components = {
		"Core": {
			"Buttons": [
				{ label: "Button", href: "#/p/components/core/buttons/button" },
				{ label: "ButtonGroup", href: "#/p/components/core/buttons/buttongroup" },
			],
			"Form": [
				{ label: "Checkbox", href: "#/p/components/core/form/checkbox" },
				{ label: "InputText", href: "#/p/components/core/form/inputtext" },
				{ label: "PasswordInput", href: "#/p/components/core/form/passwordinput" },
				{ label: "TextArea", href: "#/p/components/core/form/textarea" },
				{ label: "FileInput", href: "#/p/components/core/form/fileinput" },
				{ label: "InputFilters", href: "#/p/components/core/form/inputfilters" },
				{ label: "Dropdown", href: "#/p/components/core/form/dropdown" },
			],
			"Overlay": [
				{ label: "Dialog", href: "#/p/components/core/overlay/dialog" },
				{ label: "AlertDialog", href: "#/p/components/core/overlay/alertdialog" },
				{ label: "Popover", href: "#/p/components/core/overlay/popover" },
				{ label: "Navbar", href: "#/p/components/core/overlay/navbar" },
				{ label: "Message", href: "#/p/components/core/overlay/message" },
			],
			"Panels": [
				{ label: "Panel", href: "#/p/components/core/panels/panel" },
				{ label: "TabPane", href: "#/p/components/core/panels/tabpane" },
				{ label: "Fieldset", href: "#/p/components/core/panels/fieldset" },
				{ label: "Accordion", href: "#/p/components/core/panels/accordion" },
				{ label: "ScrollPanel", href: "#/p/components/core/panels/scrollpanel" },
			],
		},
		"Variables": {
			"Scheme": [
				{ label: "Scheme.PRIMARY", href: "#/components/sensors/resizesensor" },
				{ label: "Scheme.SECONDARY", href: "#/components/sensors/viewportsensor" },
			],
			"FilePreviewType": [
				{ label: "FilePreviewType.NONE", href: "#/components/functions/buildformdata" },
				{ label: "FilePreviewType.IMAGE", href: "#/components/functions/getfiledetails" },
			]
		},
		"Utilities": {
			"Sensors": [
				{ label: "ResizeSensor", href: "#/components/sensors/resizesensor" },
				{ label: "ViewportSensor", href: "#/components/sensors/viewportsensor" },
			],
			"Functions": [
				{ label: "buildFormData", href: "#/components/functions/buildformdata" },
				{ label: "getFileDetails", href: "#/components/functions/getfiledetails" },
			]
		},
	};

	render() {

		return (
			<Panel className="norseu-showcase-component-page">
				<h1>Overview</h1>
				<span>All components, utililites and functions provided by norseu</span>
				
				<div className="components-overview">
					{Object.keys(ComponentsOverviewPage.Components).map(group => {
						return (
							<div className="sections" key={group}>
								<span className="title">{group}</span>
								<div className="list">
									{Object.keys(ComponentsOverviewPage.Components[group]).map(section => {
										return (
											<div className="section" key={section}>
												<span className="title">{section}</span>
												{ComponentsOverviewPage.Components[group][section].map(item => <a key={item.label} href={item.href}>{item.label}</a>)}
											</div>
										)
									})}
								</div>
							</div>
						);
					})}
				</div>
			</Panel>
		)
	}
}
